import { Navigate } from 'react-router';
import { Result, Spin } from 'antd';
import { useUser } from '@clerk/clerk-react';

interface AdminGuardProps {
  children: React.ReactNode;
}

export function AdminGuard({ children }: AdminGuardProps) {
  const { isLoaded, isSignedIn, user } = useUser();

  if (!isLoaded) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (!isSignedIn || !user) {
    return <Navigate to="/login" replace />;
  }

  const role = (user.publicMetadata as { role?: string })?.role;

  if (role !== 'admin') {
    return (
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
      />
    );
  }

  return <>{children}</>;
}
